import { createContext, type Context } from 'react';
import noop from 'lodash/noop';
import type { ClassName } from '../../types';

export type StyleMarshalContextProps = {
	// eslint-disable-next-line jira/react/handler-naming
	insert: (className: ClassName, rule: string) => void;
	// eslint-disable-next-line jira/react/handler-naming
	remove: (className: ClassName) => void;
};

const { Provider, Consumer }: Context<StyleMarshalContextProps> = createContext({
	insert: noop,
	remove: noop,
});

export { Provider, Consumer };
